import Component from './component.vue';

export default Component;



// WEBPACK FOOTER //
// ./src/components/calendar/head/index.ts